import React, {PropsWithChildren, createContext, useMemo} from 'react';
import {useCurrentPageType} from './PageTypeContext';
import {usePageTypePathsMap} from './RouterContext';
import {getParams} from './getParams';
import {usePathname} from './useLocation';

export const ParamsContext = createContext<Record<string, string>>({});

export function ParamsProvider({children}: PropsWithChildren) {
  const pathname = usePathname();
  const currentPageType = useCurrentPageType();
  const pageTypePathsMap = usePageTypePathsMap();

  const params = useMemo(
    () => getParams({currentPageType, pageTypePathsMap, pathname}),
    [currentPageType, pageTypePathsMap, pathname],
  );

  return (
    <ParamsContext.Provider value={params}>{children}</ParamsContext.Provider>
  );
}
